/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m15.5538 30.2483c-.079 0-.159-.01-.239-.029-.447-.11-.761-.51-.761-.971v-11.554h-11.554c-.46 0-.861-.314-.971-.762-.11-.447.1-.911.509-1.125l26.247-13.694c.388-.202.86-.129 1.17.18.309.308.382.782.18 1.169l-13.695 26.249c-.175.336-.52.537-.886.537zm-8.475-14.554h8.475c.552 0 1 .448 1 1v8.476l10.336-19.812z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;